import React, { useState } from 'react';
import { Form, Input, Label, Title } from 'styles/common/FormStyle';
import { CommonWrapper, Background } from 'styles/common/Layout';
import { ButtonOutline } from 'styles/common/ButtonStyle';
import { resetPassword } from 'api/user';
import { useNavigate } from 'react-router-dom';

function ResetPassword() {
    const navigate = useNavigate();

    const [form, setform] = useState({
        password: "",
        newPassword: "",
        confirmPassword: "",
    });

    const formComplete = form?.password && form?.newPassword && form?.confirmPassword && form?.newPassword === form?.confirmPassword;

    const handleChange = (e) => {
        setform({ ...form, [e.target.name]: e.target.value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            await resetPassword(form);
            alert("비밀번호가 변경되었습니다.");
            navigate("/");
        } catch (error) {
            alert(error);
        }
    };

    return (
        <Background>
        <CommonWrapper>
            <Form onSubmit={handleSubmit}>
                <Title>비밀번호 변경</Title>
                <Label htmlFor="password">현재 비밀번호</Label>
                <Input
                    type="password"
                    id="password"
                    name="password"
                    value={form?.password}
                    onChange={handleChange}
                    placeholder="현재 비밀번호를 입력해주세요."
                />
                <Label htmlFor="newPassword">새 비밀번호</Label>
                <Input
                    type="password"
                    id="newPassword"
                    name="newPassword"
                    value={form?.newPassword}
                    onChange={handleChange}
                    placeholder="새 비밀번호를 입력해주세요."
                />
                <Label htmlFor="confirmPassword">비밀번호 확인</Label>
                <Input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={form?.confirmPassword}
                    onChange={handleChange}
                    placeholder="새 비밀번호를 다시 입력해주세요."
                />
                <ButtonOutline type="submit" disabled={!formComplete}>확인</ButtonOutline>
            </Form>
        </CommonWrapper>
    </Background>
    );
}

export default ResetPassword;
